import * as React from 'react';
import '@progress/kendo-theme-default/dist/all.css';

import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import $ from 'jquery'
// import { IntlProvider, load, loadMessages, LocalizationProvider } from '@progress/kendo-react-intl';

// import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
// import currencyData from 'cldr-core/supplemental/currencyData.json';
// import weekData from 'cldr-core/supplemental/weekData.json';
// import numbers from 'cldr-numbers-full/main/pt/numbers.json';
// import caGregorian from 'cldr-dates-full/main/pt-PT/ca-gregorian.json';
// import dateFields from 'cldr-dates-full/main/pt-PT/dateFields.json';
// import timeZoneNames from 'cldr-dates-full/main/pt-PT/timeZoneNames.json';
// import esMessages from '../../lang/tlklang.json';

var moment = require('moment')
const dateFormat = "yyyy-MM-dd";

// load(
//     likelySubtags,
//     currencyData,
//     weekData, numbers,
//     caGregorian,
//     dateFields,
//     timeZoneNames
// );
// loadMessages(esMessages, 'pt-PT');

class DateRange extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.defaultValue
            && Object.keys(this.props.defaultValue).filter(_ => this.props.defaultValue[_] === null).length === 2
            && JSON.stringify(prevProps.defaultValue) !== JSON.stringify(this.props.defaultValue)
        ) {
            $('.date-range-holder .k-input').each(function(index, elem) {
                setTimeout(() => {
                    $(elem).attr({
                        title: 'ano-mês-dia'
                    }).val('ano-mês-dia')
                }, 50)
            });
        }
    }

    handleInputChange = (e) => {
        this.props.handleInputChange(this.props.inputOption.key, e);
    }

    /*   Para desativar os dados de acordo com a condição */
    disabledDate = (current) => {
        return current && current > moment().endOf('day');
    }
    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("........",this.props)
        return (
            // <LocalizationProvider language="pt-PT">
            //     <IntlProvider locale="pt-PT" >
                    this.props.defaultValue ?
                    <DateRangePicker
                        max={new Date()}
                        value={this.props.defaultValue}
                        disabledDate={this.disabledDate}
                        format={dateFormat}
                        onChange={(e) => this.handleInputChange(e)}
                    />
                    :
                    <DateRangePicker
                        max={new Date()}
                        disabledDate={this.disabledDate}
                        format={dateFormat}
                        onChange={(e) => this.handleInputChange(e)}
                    />
            //     </IntlProvider>
            // </LocalizationProvider>
        );
    }
}

export default DateRange;